import AppInicio from '@/pages/home/components/AppInicio';

// A raiz é a vitrine que vende para todo mundo — logado, visitante, no app ou
// no computador. Ninguém precisa entrar para ver os eventos; o login só entra
// na hora de comprar/inscrever (do mesmo jeito que antes).
export default function Home() {
  return <AppInicio />;
}